<template>
	<div ref="CoordiPopup" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -400px); max-width: 960px;">
			<form @submit.stop="doValidation()">
				<div class="home-title">
					<div class="title-left" style="font-size: 20px;">
						<img style="width: 19px; height: 21px;" src="@/assets/images/login/coodi_icon.png" />
						<span>코디네이터 상세정보</span>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<!-- <span class="dialog-tag">참여자 정보</span> -->
						<table class="tb-crud-horizon popup-table">
							<colgroup>
								<col width="140px" />
								<col width="300px" />
								<col width="140px" />
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th>코디네이터 아이디</th>
									<td>
										{{ user.userId }}
									</td>
									<th>이름</th>
									<td>
										{{ user.userName }}
									</td>
								</tr>
								<tr>
									<th>전화번호</th>
									<td>
										{{ user.mobileTelno }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<!-- <div class="content-line">
					<div class="dot-one-line"></div>
					<div class="line-title">출산 전 지원 내역</div>
					<div class="dot-one-line"></div>
				</div> -->
				<div class="login-mode" style="background-color: #EBF4FF; border-radius: 5px; margin-top: 20px;">
					<button type="button" style="margin: 0; height: 40px; width: 49%;" :class="isMode == 1 ? 'mode' : ''" @click="selectMode(1)">출산전 지원 내역</button>
					<button type="button" style="margin: 0; height: 40px; width: 49%;" :class="isMode == 2 ? 'mode' : ''" @click="selectMode(2)">출산후 지원 내역</button>
				</div>
				<div class="center dialog-flex">
					<div>
						<div style="display: flex; justify-content: space-between; align-items: center;">
							<span class="dialog-tag">알림 전송 내역</span>
							<!-- <button class="add-btn" style="min-width: 80px; height: 32px; padding: 0 28px" >알림 설정 내역 확인하기</button> -->
						</div>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="10%">
								<col width="15%">
								<col width="auto">
								<col width="15%">
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th style="text-align: center; border-right: 1px solid #ddd;">번호</th>
									<th style="text-align: center; border-right: 1px solid #ddd;">참여자 번호</th>
									<th style="text-align: center; border-right: 1px solid #ddd;">내용</th>
									<th style="text-align: center;">일시</th>
								</tr>
								<template
									v-for="(alarm, index) in alarmList"
								>
									<tr
										:key="index + 'alarm'"
									>
										<td style="border-left: none; text-align: center;">
											{{ index+1 }}
										</td>
										<td style="text-align: center;">
											{{ alarm.userId }}
										</td>
										<td>
											{{ alarm.alarmContents }}
										</td>
										<td style="text-align: center;">
											{{ alarm.createDate.substring(0, 11) }}
										</td>
									</tr>
								</template>
								<tr v-if="alarmList.length == 0">
									<td colspan="4" class="no-list" style="border-left: none; text-align: center;">
										내역이 존재하지 않습니다.
									</td>
								</tr>
							</tbody>
						</table>
						<div class="pagination-wrap" style="position: static;">
							<pagination
								:data="pagination"
								:show-disabled="true"
								:limit="4"
								@pagination-change-page="doSearchPage"
							>
								<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
								<button type="button" slot="next-nav" class="page-next">&gt;</button>
							</pagination>
						</div>
					</div>
				</div>
				<div class="center dialog-flex">
					<div>
						<div style="display: flex; justify-content: space-between; align-items: center;">
							<span class="dialog-tag">응급 지원 내역</span>
							<!-- <button class="add-btn" style="min-width: 80px; height: 32px; padding: 0 28px" >알림 설정 내역 확인하기</button> -->
						</div>
						<table class="tb-crud-horizon popup-table" style="margin-top: 12.5px;">
							<colgroup>
								<col width="10%">
								<col width="15%">
								<col width="auto">
								<col width="15%">
							</colgroup>
							<tbody>
								<tr style="border-top: 1px solid #191C26">
									<th style="text-align: center; border-right: 1px solid #ddd;">번호</th>
									<th style="text-align: center; border-right: 1px solid #ddd;">참여자 번호</th>
									<th style="text-align: center; border-right: 1px solid #ddd;">내용</th>
									<th style="text-align: center;">일시</th>
								</tr>
								<template
									v-for="(emergency, index) in emergencyList"
								>
									<tr
										:key="index + 'emergency'"
									>
										<td style="border-left: none; text-align: center;">
											{{ index+1 }}
										</td>
										<td style="text-align: center;">
											{{ emergency.userId }}
										</td>
										<td>
											{{ emergency.emergencyContents }}
										</td>
										<td style="text-align: center;">
											{{ emergency.createDate.substring(0, 11) }}
										</td>
									</tr>
								</template>
								<tr v-if="emergencyList.length == 0">
									<td colspan="4" class="no-list" style="border-left: none; text-align: center;">
										내역이 존재하지 않습니다.
									</td>
								</tr>
							</tbody>
						</table>
						<div class="pagination-wrap" style="position: static;">
							<pagination
								:data="pagination2"
								:show-disabled="true"
								:limit="4"
								@pagination-change-page="doSearchPage2"
							>
								<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
								<button type="button" slot="next-nav" class="page-next">&gt;</button>
							</pagination>
						</div>
					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px; margin-top: 50px;">
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "CoordiPopup",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.items = {
			userNo: this.user.userNo
		}
		this.selectCoordiAlarmList();
		this.selectCoordiEmergencyList();
	},
	data() {
		return {
			items: {},
			isMode: 1,
			alarmList: [],
			emergencyList: [],
			pagination: {},
			pagination2: {},
		};
	},
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	methods: {
		selectMode(code){
			if(code == 1){ 
				this.isMode = 1;
				this.selectCoordiAlarmList();
				this.selectCoordiEmergencyList();
			}
			else{
				this.isMode = 2;
				this.alarmList = [];
				this.emergencyList = [];
				this.pagination = {};
				this.pagination2 = {};
			}
		},
		selectCoordiAlarmList(){
			this.logger.debug(this, "selectCoordiAlarmList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/alarm/selectCoordiAlarmList.do", this.items)
				.then((response) => {
					console.log(response);
					this.alarmList = response.data.alarmList;
					this.pagination = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectCoordiEmergencyList(){
			this.logger.debug(this, "selectCoordiEmergencyList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/alarm/selectCoordiEmergencyList.do", this.items)
				.then((response) => {
					console.log(response);
					this.emergencyList = response.data.emergencyList;
					this.pagination2 = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.items.pageNum = page;
			this.selectCoordiAlarmList();
		},
		doSearchPage2(page) {
			this.logger.debug(this, "doSearchPage2()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.items.pageNum = page;
			this.selectCoordiEmergencyList();
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.CoordiPopup.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.CoordiPopup.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.dot-one-line{
	flex: 1;
	border: 1px dashed #72797F;
}
.content-line{
	display: flex;
    align-items: center;
    justify-content: center;
	margin-top: 30px;
}
.line-title{
	width: 140px;
	height: 32px;
	border-radius: 16px;
	background-color: #72797F;
	color: #fff;
	font-size: 16px;
	display: flex;
    justify-content: center;
    align-items: center;
}
.login-mode{
    width: 100%;
	height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 6px;
}
.login-mode > button{
    background-color:#EBF4FF;
    width: 50%;
    height: 48px;
    border-radius: 5px;
    font-size: 18px;
}
.login-mode > button:hover{
    background-color: #1A7AFF;
    border: 1px solid #1A7AFF;
    color: #FFF;
}
.mode{
    background-color: #1A7AFF !important;
    border: 1px solid #1A7AFF;
    color: #FFF;
}
</style>